<template>
	<form
		:class="[
			'input-sigarus',
			{ 'align-right': type.includes('number') || type.includes('id') || type.includes('go')}, 
			{ editing }, 
			{ editable: !readonly },
			input ? input.class : ''
		]"
		v-click-outside="cancel"
		@submit.prevent="save"
		@keydown.enter="type == 'textarea' ? '' : save"
		@keydown.ctrl.enter.stop.prevent="save"
		@keydown.esc.capture="cancel"
		@input="error = false"
		@keydown.shift.tab.exact="back"
		@keydown.tab.exact="next"
		novalidate="true"
	>

		<el-popover
			v-if="mode === 'inline'"
			v-model="showTooltip"
			placement="top"
			title=""
			trigger="manual">

			<el-alert v-if="error" type="error" effect="dark" :closable="false">{{ error }}</el-alert>

			<div
				ref="a"
				class="holder"
				slot="reference"
				@click="ondblclick"
			>

				<div
					v-show="!editing && !hideInput"
					class="label"
				>	
					<el-input 
						v-if="type == 'textarea'"
						type="textarea"
						rows="4"
						readonly
						:value="value"/>
					<template v-else>
						<div v-if="[null,''].includes(value)" class="placeholder truncate">
							{{ placeholder }}
						</div>
						<div v-else class="truncate">
							<div v-if="typeof value == 'object' && value.length <= 0" style="min-height: 20px;"></div>
							<div v-else v-html="`${input && input.textpre ? input.textpre : ''} ${render(value)} ${input && input.textpos ? input.textpos : ''}`"></div>
						</div>
					</template>

				</div>

				<div :class="[{ editing }]" :style="{'flex-shrink': ['id'].includes(extraType) ? 0 : 1}">
					
					<component
						v-show="editing"
						ref="input"
						class="input-sigarus-component"
						:is="`l-${mainType}`"
						:key="`l-${mainType}`"
						:editing="editing"
						size="small"
						v-model="model"
						v-bind.sync="{...$attrs, ...$props}"
						@focus="$emit('focus')"
						@blur="$emit('blur')"
						@input="onInput"
						@save="save"
					/>

					<div v-show="editing && showDeleteButton" class="buttons buttons-editing">
						<el-button
							title="Cancelar"
							size="small"
							circle
							type="danger"
							@click.stop.prevent="cancel"
							icon="el-icon-close"
						></el-button>
					</div>

					<div v-if="extraType || tieneInternacionalizacion || (actions && actions.length)" class="buttons">

						<el-button
							v-if="['id','go'].includes(extraType)"
							title="Ver"
							size="small"
							@click.stop.prevent="$emit('go', input)"
							icon="el-icon-link"
						></el-button>

						<el-button
							v-if="['id'].includes(extraType)"
							title="Editar"
							size="small"
							:disabled="input.state == 'read-only'"
							@click.stop.prevent="$emit('id', input)"
							icon="el-icon-edit-outline"
						></el-button>

						<!-- Botón internacionalización -->
						<el-button
							v-if="tieneInternacionalizacion && identificador && entidad && !readonly && input.state !== 'read-only'"
							title="Traducciones"
							size="small"
							type="primary"
							icon="el-icon-collection-tag"
							@click.stop.prevent="abrirModalInternacionalizacion"
						></el-button>

						<!-- Acciones -->
						<el-tooltip
							v-for="action,a in actions"
							:key="a"
							class="item" 
							effect="dark" 
							:content="action ? action.titulo : ''" 
							placement="top">
								<el-button
								v-if="action"
								@click="porlet && porlet.events && porlet.events.clickAction(action)"
								type="default" 
								size="mini" 
								:icon="action.icon"
								/>
						</el-tooltip>

					</div>

				</div>

			</div>

		</el-popover>

		<div class="popover" v-else>

			<el-popover
				v-model="showTooltip"
				placement="top"
				title="Editar"
				trigger="manual"
			>

				<div class="holder">

					<el-alert
						v-if="error"
						type="error"
						effect="dark"
						:closable="false"
						style="margin-bottom: 10px;"
					>{{ error }}</el-alert>

					<div>
						
						<component
							ref="input"
							class="input-sigarus-component"
							:is="`l-${mainType}`"
							:key="`l-${mainType}`"
							:editing="editing"
							size="small"
							v-model="model"
							v-bind.sync="{...$attrs, ...$props}"
							@focus="$emit('focus')"
							@blur="$emit('blur')"
							@input="onInput"
							@save="save"
						/>
						<div v-show="editing && showDeleteButton" class="buttons buttons-editing">
							<el-button
								title="Cancelar"
								size="small"
								circle
								type="danger"
								@click.stop.prevent="cancel"
								icon="el-icon-close"
							></el-button>
						</div>

						<div v-if="extraType || tieneInternacionalizacion || (actions && actions.length)" class="buttons">

							<el-button
								v-if="['id','go'].includes(extraType)"
								title="Ver"
								size="small"
								@click.stop.prevent="$emit('go', input)"
								icon="el-icon-link"
							></el-button>

							<el-button
								v-if="['id'].includes(extraType)"
								title="Editar"
								size="small"
								:disabled="input.state == 'read-only'"
								@click.stop.prevent="$emit('id', input)"
								icon="el-icon-edit-outline"
							></el-button>

							<!-- Botón internacionalización -->
							<el-button
								v-if="tieneInternacionalizacion && identificador && entidad && !readonly && input.state !== 'read-only'"
								title="Traducciones"
								size="small"
								type="primary"
								icon="el-icon-collection-tag"
								@click.stop.prevent="abrirModalInternacionalizacion"
							></el-button>

							<!-- Acciones -->
							<el-tooltip
								v-for="action,a in actions"
								:key="a"
								class="item" 
								effect="dark" 
								:content="action ? action.titulo : ''" 
								placement="top">
									<el-button
									v-if="action"
									@click="porlet && porlet.events && porlet.events.clickAction(action)"
									type="default" 
									size="mini" 
									:icon="action.icon"
									/>
							</el-tooltip>

						</div>

					</div>

				</div>

				<div
					v-show="!hideInput"
					ref="a"
					slot="reference"
					class="label"
					@click="ondblclick"
				>

					<div v-html="render(value)"></div>

				</div>

			</el-popover>

		</div>

		<!-- Modal internacionalización -->
		<el-dialog
			v-if="tieneInternacionalizacion"
			:visible.sync="intlModal.visible"
			width="500px"
			:title="`${input && input.title ? input.title : ''}`"
			:append-to-body="true"
		>
			<el-form label-position="left" label-width="140px">
				<el-form-item label="Español">
					<template v-if="intlEsTextarea">
						<el-input
							class="input-sigarus-component intl-input"
							size="small"
							type="textarea"
							:rows="3"
							v-model="intlModal.base"
							readonly
							:disabled="true"
						/>
					</template>
					<template v-else>
						<el-input
							class="input-sigarus-component intl-input"
							size="small"
							v-model="intlModal.base"
							readonly
							:disabled="true"
						/>
					</template>
				</el-form-item>

				<el-form-item label="Inglés">
					<template v-if="intlEsTextarea">
						<el-input
							class="input-sigarus-component intl-input"
							size="small"
							type="textarea"
							:rows="3"
							v-model="intlModal.traducciones.en"
						/>
					</template>
					<template v-else>
						<el-input
							class="input-sigarus-component intl-input"
							size="small"
							v-model="intlModal.traducciones.en"
						/>
					</template>
				</el-form-item>

				<el-form-item label="Francés">
					<template v-if="intlEsTextarea">
						<el-input
							class="input-sigarus-component intl-input"
							size="small"
							type="textarea"
							:rows="3"
							v-model="intlModal.traducciones.fr"
						/>
					</template>
					<template v-else>
						<el-input
							class="input-sigarus-component intl-input"
							size="small"
							v-model="intlModal.traducciones.fr"
						/>
					</template>
				</el-form-item>
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="intlModal.visible = false">Cancelar</el-button>
				<el-button type="primary" :loading="intlModal.guardando" @click="guardarInternacionalizacion">
					Guardar
				</el-button>
			</div>
		</el-dialog>

	</form>
</template>

<script>
	import axios from 'axios'
	import _ from 'lodash'
	import inputConfig from './utils/inputConfig'
	
	import {updateInputFile, getUrl} from '@/helpers/api'

	import moment from 'moment'

	export default {
		name: 'InputSigarus',
		components: inputConfig,
		props: {
			obligatorio: {
				type: Boolean
			},
			identificador: {
				type: [String,Number]
			},
			entidad: {
				type: String
			},
			input: {
				type: Object
			},
			value: {
				default: ''
			},
			type: {
				type: String,
				default: 'text'
			},
			saveUrl: {
				type: String,
				default: ''
			},
			mode: {
				type: String,
				default: 'inline'
			},
			siblings: {
				type: Array,
				default: () => []
			},
			readonly: {
				type: Boolean,
				default: false
			},
			placeholder: {
				type: String,
				default: ''
			},
			showDeleteButton: {
                type: Boolean,
                default: false
            },
			porlet: {
				type: Object,
				required: false
			},
			actions: {
				type: Array
			}
		},
		data () {
			return {
				callHook: (h, val) => val,
				render: val => val,
				error: null,
				editing: false,
				model: '',
				hideInput: false,
				loading: false,

				modelfilter: '',

				intlModal: {
					visible: false,
					base: '',
					traducciones: {
						en: '',
						fr: ''
					},
					guardando: false
				}
			}
		},
		watch: {
			value() {
				this.model = _.cloneDeep(this.value)
			},
			loading(val) {
				this.$emit('update:busy',val)
			},
			editing() {
				if (this.input.keepalive && !this.editing) this.editing = this.input.keepalive
			},
			'input.class'() {
				if (this.input.class && this.input.class.includes('required')) {
					this.$emit('obligatorio')
				}
			}
		},
		computed: {

			showTooltip: {
				get () {

					if (this.mode === 'inline') return !!this.error

					return this.editing

				},
				set () {}
			},

			extraType () {

				const types = this.type.split(':')

				if (types.length < 2) return false

				return types[1]

			},

			mainType () { return this.type.split(':')[0] },
			intlEsTextarea () {
				// Consideramos textarea cuando el tipo principal es 'textarea'
				// o el tipo incluye explícitamente 'textarea'
				return this.mainType === 'textarea' || (typeof this.type === 'string' && this.type.indexOf('textarea') !== -1)
			},
			tieneInternacionalizacion () {
				return this.input && String(this.input.__internacionalizacion || '') === '1'
			}
		},
		mounted () {
			
			this.model = _.cloneDeep(this.value)

			if (this.$refs.input && this.$refs.input.$_callHook) this.callHook = this.$refs.input.$_callHook

			if (this.$refs.input && this.$refs.input.$render) this.render = this.$refs.input.$render

			if (this.$refs.input && this.$refs.input.overrideData) Object.assign(this.$data, this.$refs.input.overrideData())

			// Mantener input abierto
			if(this.input) this.editing = this.input.keepalive
		},
		methods: {

			async save () {

				//console.log('save')
				try {

					let val = this.model
					//console.log('save: ',val)

					val = await this.callHook('beforeSave', val)
					
					if(this.obligatorio && !val ) {
						this.$emit('obligatorio')
						return
					}

					if (this.saveUrl !== '') {

						if (this.saveUrl === 'forzar error') throw {
							message: 'Algo sa rompido',
							type: 'Error'
						}

						if (this.saveUrl === 'forzar bien') {
							
							//console.log('chachi')

						} else {
							
							this.loading = true

							let resp = null

							if(this.input.format == 'file') {
								//console.log('enío file: ',val)

								let formData = new FormData();
                    			formData.append("image", val.file)

								resp = await updateInputFile(formData, {
									id: this.identificador,
									entidad: this.entidad,
									field: this.input.key
								})

							} else {
								
								let newvalue = val
								
								if(this.input.format == 'datepicker') {

									newvalue = moment(val, 'DD/MM/YYYY').format('YYYY-MM-DD')

								} else if(this.input.format == 'datetimepicker') {

									newvalue = moment(val, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss')
								}

								resp = await axios.post(this.saveUrl, {
									id: this.identificador,
									entidad: this.entidad,
									field: this.input.key,
									newvalue: `${this.modelfilter}${newvalue}`,
									format: this.input.format,
									entidadRelacionada: this.input.entidad
								})
							}
							//console.log(resp)

							// Actualizar componente
							/*if (resp.data.recargarComponentes && resp.data.recargarComponentes.length) {
								let _self = this
								resp.data.recargarComponentes.forEach(comp => {
									_self.$referencias[comp].refresh()
								})
							}*/

							this.loading = false
							
							if (resp && typeof resp.data !== "object") {

								throw {
									message: resp.errorMensaje || 'Ha ocurrido un error al guardar',
									type: 'Error'
								}

							} else if (resp.data.mensajes) {

								this.$emit('saved', resp.data)

							}
							
						}

					}

					val = await this.callHook('afterSave', val)

					this.$emit('input', val)

					this.model = val

					this.stopEditing()

				}
				catch (err) {
					
					this.error = err.response.data.errorMensaje

					if (this.$refs.input.focus) this.$refs.input.focus()

					this.loading = false

				}

			},

			async abrirModalInternacionalizacion () {

				if (!this.entidad || !this.identificador || !this.input) {
					this.$message && this.$message.error && this.$message.error('Faltan datos para cargar las traducciones')
					return
				}

				try {
					const endpoints = getUrl()
					if (!endpoints) {
						this.$message && this.$message.error && this.$message.error('Error de configuración')
						return
					}

					const url = `${endpoints.backend}input/obtenerInternacionalizacion`
					const resp = await axios.get(url, {
						params: {
							entidad: this.entidad,
							id: this.identificador,
							field: this.input && this.input.key ? this.input.key : (this.inputName || this.input.nombre || this.input.campo || this.input.field)
						}
					})

					const data = resp.data || {}
					this.intlModal.base = data.base || (this.value || '')
					this.intlModal.traducciones = Object.assign(
						{ en: '', fr: '' },
						data.traducciones || {}
					)
					this.intlModal.visible = true
				} catch (e) {
					console.error('Error al obtener internacionalización:', e)
					this.$message && this.$message.error && this.$message.error('Error al cargar las traducciones del campo')
				}
			},

			async guardarInternacionalizacion () {
				if (!this.entidad || !this.identificador || !this.input) {
					this.$message && this.$message.error && this.$message.error('Faltan datos para guardar las traducciones')
					return
				}

				this.intlModal.guardando = true
				try {
					const endpoints = getUrl()
					if (!endpoints) {
						this.$message && this.$message.error && this.$message.error('Error de configuración')
						this.intlModal.guardando = false
						return
					}

					const url = `${endpoints.backend}input/guardarInternacionalizacion`
					const fieldName = this.input && this.input.key ? this.input.key : (this.inputName || this.input.nombre || this.input.campo || this.input.field)
					const locales = ['en', 'fr']

					for (const locale of locales) {
						const valor = this.intlModal.traducciones[locale]
						await axios.post(url, {
							entidad: this.entidad,
							id: this.identificador,
							field: fieldName,
							locale,
							valor: valor == null ? '' : valor
						})
					}

					this.$message && this.$message.success && this.$message.success('Traducciones guardadas correctamente')
					this.intlModal.visible = false
				} catch (e) {
					console.error('Error al guardar internacionalización:', e)
					this.$message && this.$message.error && this.$message.error('Error al guardar las traducciones')
				} finally {
					this.intlModal.guardando = false
				}
			},

			async cancel () {
				
				try {

					let val = this.value

					val = await this.callHook('beforeCancel', val)

					val = await this.callHook('afterCancel', val)

					this.model = val

					this.stopEditing()

				}
				catch (err) {
					console.log(err)
					this.error = err.response.data.errorMensaje

					if (this.$refs.input.focus) this.$refs.input.focus()

				}

			},

			async onInput (val) {

				try {

					this.error = false

					val = await this.callHook('input', val)

					this.model = val

					if(this.saveUrl == '') {
						this.$emit('input', val)
					}

				} catch(err) {
					
					this.error = err.response.data.errorMensaje

					if (this.$refs.input.focus) this.$refs.input.focus()

				}

			},

			async ondblclick () {

				if(this.readonly || this.editing) return

				let val = this.model

				val = await this.callHook('startEditing', val)

				this.model = val

				this.editing = true

				setTimeout(() => {

					if (this.$refs.input.focus) this.$refs.input.focus()
					if (this.$refs.input.select) this.$refs.input.select()

				}, 100)

			},

			async stopEditing () {

				let val = this.model

				val = await this.callHook('endEditing', val)

				this.model = val

				this.editing = false

				this.error = false

				//setTimeout(() => this.$refs.a.focus(), 200)

			},

			async next (e) {

				if (this.siblings.length === 0) return

				let index = this.siblings.indexOf(this) + 1

				if (index > this.siblings.length - 1) index = 0
				
				if(this.model != this.value) {
					
					await this.save()
					if(this.error) return

				}
					
				this.stopEditing()
				
				//console.log('next', index)
				this.siblings[index].ondblclick()

			},

			async back (e) {

				if (this.siblings.length === 0) return

				let index = this.siblings.indexOf(this) - 1

				if (index < 0) index = this.siblings.length - 1

				if(this.model != this.value) {

					await this.save()
					if(this.error) return

				}
					
				this.stopEditing()
				
				//console.log('back', index)
				this.siblings[index].ondblclick()

			}

		}
	}
</script>

<style lang="scss">
	@import '@/assets/scss/variables.scss';
	form {
		&.align-right {
			.label, input {
				text-align: right!important;
			}
			.editing {
    			justify-content: flex-end;
			}
		}
		&.editable {
			.label {
				color: $--color-primary; //#409eff;
			}
			&:hover {
				background-color: $--color-editable; //#409eff0d
				cursor: pointer;
			}
		}
		&.txt-left input,
		&.txt-left .truncate {
			text-align: left!important;
		}
		&.txt-center input,
		&.txt-center .truncate {
			text-align: center!important;
		}
		&.txt-right input,
		&.txt-right .truncate,
		&.txt-right .editing {
			text-align: right!important;
			justify-content: flex-end;
		}

		input {
			border-radius: 0px!important;
		}

		input, textarea {
			font-family: 'Nunito Sans'!important;
			padding: 0 0.50rem!important;
		}

	}

	// Estilos específicos para los inputs del modal de internacionalización
	.intl-input {
		.el-input__inner,
		.el-textarea__inner {
			border-radius: 6px !important;
			border-color: #dcdfe6 !important; // gris claro más suave
		}
	}

	.el-popover:focus {
		border: 1px solid #DCDFE6;
		border-radius: 5px;
		outline: 0;
	}

	.label {
		//min-height: 32px;
		line-height: 32px;
		padding: 0 0.50rem;
		border: 0px;
		box-sizing: border-box;
		color: #303133;
    	border-radius: 0px;

		&:focus {
			//border: 1px solid #DCDFE6;
			//border-radius: 5px;
			outline: 0;
		}

		&.align-right {
			text-align: right;
		}
		.truncate {
			overflow: hidden;
			text-overflow: ellipsis;
			&.placeholder {
				height: 32px;
			}
		}
		textarea {
			border: 0px;
			color: $--color-primary!important;
			padding: 0px!important;
			background-color: transparent;
		}
	}

	.holder {
		display: flex;
		justify-content: flex-end;

		&>div:first-child {
			flex-grow: 1;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			font-size: 0.8rem;
		}

		&>div:last-child {
			display: flex;
			align-items: center;

			&.editing {
				flex-grow: 1;
				&.filter {
					flex-flow: column;
				}
			}

			&>.input-sigarus-component {
				flex-grow: 1;
			}

			&>.buttons {
				flex-shrink: 0;
				margin-left: 1px;

				&>* {
					margin-left: 1px !important;
				}

				&.buttons-editing {
					position: absolute;
    				right: -41px;
					z-index: 9;
				}

				> button {
					padding: 7px 15px;
				}
			}
		}
	}

	

</style>
